import { Outlet, NavLink, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  Cog6ToothIcon,
  UsersIcon,
  ServerStackIcon,
  KeyIcon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  ArrowLeftIcon,
} from '@heroicons/react/24/outline';

const adminNavItems = [
  { name: 'Dashboard', href: '/admin', icon: ChartBarIcon, end: true },
  { name: 'API Credentials', href: '/admin/api-config', icon: KeyIcon },
  { name: 'Users', href: '/admin/users', icon: UsersIcon },
  { name: 'System Health', href: '/admin/monitoring', icon: ServerStackIcon },
  { name: 'Settings', href: '/admin/settings', icon: Cog6ToothIcon },
  { name: 'Activity Logs', href: '/admin/logs', icon: ClipboardDocumentListIcon },
];

export default function AdminLayout() {
  const { user } = useAuth();

  // Redirect non-admins
  if (user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Admin Header */}
      <div className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <NavLink
                to="/dashboard"
                className="flex items-center text-gray-400 hover:text-white mr-6"
              >
                <ArrowLeftIcon className="h-5 w-5 mr-2" />
                Back to App
              </NavLink>
              <h1 className="text-xl font-semibold">Admin Panel</h1>
            </div>
            <div className="text-sm text-gray-400">
              Logged in as <span className="text-white">{user?.email}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex gap-8">
          {/* Sidebar Navigation */}
          <nav className="w-64 flex-shrink-0">
            <div className="bg-white rounded-lg shadow-sm p-4">
              <ul className="space-y-1">
                {adminNavItems.map((item) => (
                  <li key={item.name}>
                    <NavLink
                      to={item.href}
                      end={item.end}
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2.5 text-sm font-medium rounded-lg transition-colors ${
                          isActive
                            ? 'bg-green-50 text-green-700'
                            : 'text-gray-700 hover:bg-gray-50'
                        }`
                      }
                    >
                      <item.icon className="h-5 w-5 mr-3" />
                      {item.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          {/* Main Content */}
          <main className="flex-1 min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
